import React from "react";
import { DnDContext } from "./DnDContext";

export const DnDInput: React.FC = (props) => {
  return (
    <DnDContext.Consumer>
      {(dndCtx) => {
        if (!dndCtx || !dndCtx.dzProps) {
          return null;
        }

        return <input {...dndCtx.dzProps.getInputProps()} />;
      }}
    </DnDContext.Consumer>
  );
};

export default DnDInput;
